// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeaturesNew_features__F4Ciz {
  padding: 6rem;
  background-color: var(--color-white);
}
@media only screen and (max-width: 50em) {
  .FeaturesNew_features__F4Ciz {
    padding: 6rem 4rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .FeaturesNew_features__F4Ciz {
    padding: 6rem 3rem;
  }
}
.FeaturesNew_features__together__F22LQ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 2rem;
  row-gap: 6rem;
  padding: 7rem 9rem;
}
@media only screen and (max-width: 62.5em) {
  .FeaturesNew_features__together__F22LQ {
    padding: 7rem 2rem;
  }
}
@media only screen and (max-width: 50em) {
  .FeaturesNew_features__together__F22LQ {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 31.25em) {
  .FeaturesNew_features__together__F22LQ {
    grid-template-columns: 100%;
    row-gap: 3rem;
  }
}
.FeaturesNew_features__services__Xhlkv {
  background-color: var(--color-light);
  border: 1px solid var(--color-grey-3);
  padding: 5rem 3rem;
  border-radius: 1.5rem;
  box-sizing: border-box;
}
.FeaturesNew_features__services__icon__2Tx2b {
  font-size: 5rem;
  color: var(--color-primary);
}
.FeaturesNew_features__btn__qF7wq {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 7rem;
}
@media only screen and (max-width: 37.5em) {
  .FeaturesNew_features__btn__qF7wq {
    flex-direction: column;
    align-items: center;
  }
}

.FeaturesNew_btn__icon__4i\\+Cg {
  height: 2.2rem;
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/FeaturesNew.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,oCAAA;AADD;AAGC;EAJD;IAKE,kBAAA;EAAA;AACF;AAEC;EARD;IASE,kBAAA;EACA;AACF;AAEC;EACC,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAAF;AAEE;EAPD;IAQE,kBAAA;EACD;AACF;AACE;EAXD;IAYE,qCAAA;EAED;AACF;AAAE;EAfD;IAgBE,2BAAA;IACA,aAAA;EAGD;AACF;AAAC;EACC,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAEF;AAIE;EACC,eAAA;EACA,2BAAA;AAFH;AAMC;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAJF;AAME;EAND;IAOE,sBAAA;IACA,mBAAA;EAHD;AACF;;AAUC;EACC,cAAA;EACA,kBAAA;AAPF","sourcesContent":["@import '../variables/breakpoints';\n\n.features {\n\tpadding: 6rem;\t\n\tbackground-color: var(--color-white);\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tpadding: 6rem 4rem;\t\n\t}\n\t\n\t@media only screen and (max-width: $bp-600) {\n\t\tpadding: 6rem 3rem;\t\n\t}\n\t\n\n\t&__together {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\t\t\n\t\tcolumn-gap: 2rem;\n\t\trow-gap: 6rem;\t\t\n\t\tpadding: 7rem 9rem;\t\n\t\t\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tpadding: 7rem 2rem;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\t\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tgrid-template-columns: 100%;\n\t\t\trow-gap: 3rem;\t\n\t\t}\n\t}\n\n\t&__services {\t\t\n\t\tbackground-color: var(--color-light);\n\t\tborder: 1px solid var(--color-grey-3);\n\t\tpadding: 5rem 3rem;\n\t\tborder-radius: 1.5rem;\n\t\tbox-sizing: border-box;\n\t\t\n\t\t\n\n\n\n\t\t&__icon {\n\t\t\tfont-size: 5rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__btn {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 7rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\t\n\t\t}\n\t}\n}\n\n// button style\n\n.btn {\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"features": `FeaturesNew_features__F4Ciz`,
	"features__together": `FeaturesNew_features__together__F22LQ`,
	"features__services": `FeaturesNew_features__services__Xhlkv`,
	"features__services__icon": `FeaturesNew_features__services__icon__2Tx2b`,
	"features__btn": `FeaturesNew_features__btn__qF7wq`,
	"btn__icon": `FeaturesNew_btn__icon__4i+Cg`
};
export default ___CSS_LOADER_EXPORT___;
